import { InfoModal as t } from "./info-modal.js";
import { WillInfoModal as l } from "./will-info-modal.js";
const o = "terms-accepted";
export {
  t as InfoModal,
  o as TERMS_ACCEPTED_ID,
  l as WillInfoModal
};
